import {
  CategoryConfigurationDefinitionResponse,
  ConfigurationDataType,
  ConfigurationFieldType,
  ConfigurationSectionType,
} from '@ydistri/api-sdk';
import { ConfigurationRowLayout } from './SegmentPotentialDefinition/ConfigurationRow';

// Field types that belong to Redistribution sets configuration sections
const redistributionSetsConfigurations: Partial<
  Record<ConfigurationSectionType, ConfigurationFieldType[]>
> = {
  [ConfigurationSectionType.PotentialSourceStandardSubsection]: [
    ConfigurationFieldType.PsUseStrictSets,
    ConfigurationFieldType.PsUseMinCostUnitPriceForSets,
    ConfigurationFieldType.PsMinCostUnitPriceForSets,
    ConfigurationFieldType.PsUseSmartSets,
    ConfigurationFieldType.PsUseMinRedistributionQuantity,
    ConfigurationFieldType.PsAllowBreakSetsMinQuantitiesWhenGoingToZero,
    ConfigurationFieldType.PsUseHfmq,
    ConfigurationFieldType.PsHfmqPairs,
  ],
  [ConfigurationSectionType.PotentialSourceForcedSubsection]: [
    ConfigurationFieldType.PsUseStrictSetsForced,
    ConfigurationFieldType.PsUseMinCostUnitPriceForSetsForced,
    ConfigurationFieldType.PsMinCostUnitPriceForSetsForced,
    ConfigurationFieldType.PsUseSmartSetsForced,
    ConfigurationFieldType.PsUseMinRedistributionQuantityForced,
    ConfigurationFieldType.PsAllowBreakSetsMinQuantitiesWhenGoingToZeroForced,
    ConfigurationFieldType.PsUseHfmqForced,
    ConfigurationFieldType.PsHfmqPairsForced,
  ],
};

export const isSectionTypeTarget = (st: ConfigurationSectionType): boolean =>
  [ConfigurationSectionType.PotentialTarget].includes(st);

export const isSectionTypeSource = (st: ConfigurationSectionType): boolean =>
  [
    ConfigurationSectionType.PotentialSource,
    ConfigurationSectionType.PotentialSourceStandardSubsection,
    ConfigurationSectionType.PotentialSourceForcedSubsection,
  ].includes(st);

export const entityListConfigurationDataTypes: ConfigurationDataType[] = [
  ConfigurationDataType.SelectBoxMinLayerList,
  ConfigurationDataType.SelectBoxTargetList,
  ConfigurationDataType.SelectBoxSourceList,
  ConfigurationDataType.SelectBoxForcedList,
];

export const isRedistributionSetConfigurationSection = (
  sectionType: ConfigurationSectionType,
  fieldType: ConfigurationFieldType,
): boolean => {
  const fields = redistributionSetsConfigurations[sectionType];

  if (fields) {
    return fields.includes(fieldType);
  } else {
    return false;
  }
};

export const computeConfigurationRowLayout = (
  definition: CategoryConfigurationDefinitionResponse,
): ConfigurationRowLayout => {
  let computedLayout: ConfigurationRowLayout;
  if (isSectionTypeSource(definition.sectionType)) {
    if (isRedistributionSetConfigurationSection(definition.sectionType, definition.fieldType)) {
      computedLayout = 'single';
    } else {
      computedLayout = 'skuTypes';
    }
  } else if (isSectionTypeTarget(definition.sectionType)) {
    computedLayout = 'single';
  } else {
    computedLayout = 'children';
  }

  return computedLayout;
};
